import { render, staticRenderFns } from "./SiteTenancy.vue?vue&type=template&id=1bdbc030"
import script from "./SiteTenancy.vue?vue&type=script&lang=js"
export * from "./SiteTenancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports